import { useEffect, useState } from 'react';
import Header from '../componets/headerwebsite/headerweb';
import FooterWeb from '../componets/footerwebsite/footerweb';
import page from "../../assets/categorypage-background.png";
import homepage from "../../assets/home-about-1.png";
import background from "../../assets/background-for-all.png";
import './aboutpageweb.css';
import { GET, POST } from '../../utils/apicalls';
import { API } from '../../config/api';
import { Button, Form, Input, notification } from 'antd';
import { Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faPen } from '@fortawesome/free-solid-svg-icons';

function Aboutpageweb() {
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();
    const [coreValuesdata, setcorevaluesData] = useState<any>({});
    const [AboutData, setAboutData] = useState<any>([]);
    const submitHandler = async (values: any) => {
        try {
            let obj = {

                customerName: values.customerName,
                customerEmail: values.customerEmail,
                mobile_number: values.mobile_number,
                customerSubject: values.customerSubject,
                message: values.message,

            };

            setIsLoading(true);
            const postRequest: any = await POST(API.CREATE_CONTACT_MESSAGE, obj);

            if (postRequest.status) {
                notification.success({ message: "message send successfully!" });
                form.resetFields();

            } else {
                notification.error({ message: "Something went wrong" });
            }
        } catch (error) {
            console.error(error);
            notification.error({
                message: "Something went wrong! Please try again later",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const fetchCorevalues = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.CORE_VALUES, {});
            setcorevaluesData(response?.data || []);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };


    const fetchAboutus = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.ABOUTUS_MANAGEMENT, {});
            setAboutData(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };



    useEffect(() => {
        fetchCorevalues();
        fetchAboutus();
    }, []);

    const [showScroll, setShowScroll] = useState(false);

    // Show the button when scrolling down
    useEffect(() => {
        const checkScrollTop = () => {
            if (window.scrollY > 300) {
                setShowScroll(true);
            } else {
                setShowScroll(false);
            }
        };
        window.addEventListener('scroll', checkScrollTop);
        return () => window.removeEventListener('scroll', checkScrollTop);
    }, []);

    // Scroll to the top when clicking the button
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className='about-container'>

            {/* Scroll to Top Button */}
            {showScroll && (
                <button className="scroll-top-button" onClick={scrollToTop}>
                    <FontAwesomeIcon icon={faArrowUp} />
                </button>
            )}
            <Header />
            <div className="about-content">
                <div className="about-header">
                    <img src={background} alt="About Us Background" />
                    <h1 className="about-title">About Us</h1>
                </div>



                {AboutData?.length > 0 ? (
                    AboutData.map((item: any, index: number) => (
                        <div key={index} className="about-section">
                            {index % 2 === 0 ? (
                                <>
                                    <img src={item.aboutImage || page} alt="About Us" />
                                    <div>
                                        <h5>{item.aboutSubtitle}</h5>
                                        <h2>{item.aboutTitle}</h2>
                                        <p>{item.aboutDescription}</p>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div>
                                        <h5>{item.aboutSubtitle}</h5>
                                        <h2>{item.aboutTitle}</h2>
                                        <p>{item.aboutDescription}</p>
                                    </div>
                                    <img src={item.aboutImage || page} alt="Core Values" />
                                </>
                            )}
                        </div>
                    ))
                ) : (
                    <p>Loading or No Data Available...</p>
                )}


                <div className="core-values">
                    <h5>Core Values </h5>
                    {coreValuesdata?.length > 0 ? (
                        coreValuesdata.map((item: any, index: any) => (
                            <div key={index} className="core-value-item">
                                <h3> <FontAwesomeIcon icon={faPen} />{item.coreValuesCaption}</h3>
                                <p style={{ fontSize: "12px", textAlign: "justify" }}>
                                    {item.coreValuesDescription}
                                </p>
                            </div>
                        ))
                    ) : (
                        <p>No core values available.</p>
                    )}
                </div>



                <div className="about-section">
                    <img src={homepage} alt="Core Values" />
                    <div>
                        <h5>Interested in discussing?</h5>
                        <hr />
                        <Form form={form} onFinish={submitHandler} layout="vertical">
                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={12}>
                                    <Form.Item
                                        name="customerName"
                                        label="Full Name"
                                        rules={[{ required: true }]}
                                    >
                                        <Input placeholder="Enter your full name" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12}>
                                    <Form.Item
                                        name="customerEmail"
                                        label="Email"
                                        rules={[
                                            { required: true, message: "Please enter your email" },
                                            { type: "email", message: "Please enter a valid email" },
                                        ]}
                                    >
                                        <Input type="email" placeholder="Enter your email" />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12}>
                                    <Form.Item
                                        name="mobile_number"
                                        label="Contact Number"
                                        rules={[{ required: true }]}
                                    >
                                        <Input placeholder="Enter your contact number" />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={[16, 16]}>

                                <Col xs={24} sm={12}>
                                    <Form.Item
                                        name="customerSubject"
                                        label="Subject"
                                        rules={[{ required: true }]}
                                    >
                                        <Input placeholder="Enter your Subject" />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={[16, 16]}>
                                <Col xs={24}>
                                    <Form.Item
                                        name="message"
                                        label="Message"
                                        rules={[{ required: true }]}
                                    >
                                        <Input.TextArea placeholder="Enter your message" />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Button type="primary" htmlType="submit" block>
                                Submit
                            </Button>
                        </Form>
                    </div>
                </div>
            </div>
            <FooterWeb />
        </div>
    );
}

export default Aboutpageweb;
